import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography
} from "@mui/material";
import React from "react";
import produce from "immer";
import { useDispatch } from "react-redux";
import {
  PayrollAttendanceSource,
  TPayrollAttendanceSource
} from "../../../../../constants/payroll";
import { resourceCentreActions } from "../../../../../actions";
import useCurrentResourceCentre from "../../../../../hooks/useCurrentResourceCentre";

// eslint-disable-next-line import/prefer-default-export
export function GeneralPayrollSettings(): React.ReactNode {
  const dispatch = useDispatch();
  const resourceCentre = useCurrentResourceCentre();

  return (
    <Box sx={{ p: 2 }}>
      <FormControl>
        <FormLabel>Attendance Source</FormLabel>

        <RadioGroup
          value={
            resourceCentre?.settings?.payrollSettings?.attendanceSource ||
            PayrollAttendanceSource.SYSTEM
          }
          onChange={(event) => {
            const newRc = produce(resourceCentre, (draft) => {
              if (draft) {
                draft.settings.payrollSettings.attendanceSource = event?.target
                  .value as TPayrollAttendanceSource;
              }
            });
            dispatch(resourceCentreActions.putResourceCentre(newRc));
          }}
          sx={{ my: 1, display: "flex", flexDirection: "column", gap: 2 }}
        >
          <FormControlLabel
            value="system"
            control={<Radio />}
            label={
              <Box>
                <Typography>System attendance</Typography>
                <Typography variant="body2" color="text.secondary">
                  Automatically use attendance records from the system for payroll calculation.
                </Typography>
              </Box>
            }
          />

          <FormControlLabel
            value="custom"
            control={<Radio />}
            label={
              <Box>
                <Typography>Custom attendance</Typography>
                <Typography variant="body2" color="text.secondary">
                  Provide attendance data manually for each employee during payroll processing.
                </Typography>
              </Box>
            }
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
}
